<template>
  <div id="app" v-cloak>
    <bg-head></bg-head>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <bg-foot></bg-foot>
  </div>
</template>

<script>
  import BgHead from './components/BgHead';
  import BgFoot from './components/BgFoot';
  export default {
    name: 'App',
    components: {
      BgHead,
      BgFoot
    }
  }
</script>

<style lang="scss">
  @import "../static/css/init.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue